// JavaScript for Switcher Functionality
document.addEventListener("DOMContentLoaded", function () {
  const switcherItems = document.querySelectorAll(".sp__switcher-item");
  const plans = document.querySelectorAll(".sp__plans-inner");

  // Function to show the plan corresponding to the clicked switcher item
  function showPlan(planLogo) {
    // Hide all plans
    plans.forEach((plan) => {
      plan.style.display = "none";
    });

    // Show the selected plan
    const selectedPlan = document.getElementById(planLogo);
    if (selectedPlan) {
      selectedPlan.style.display = "grid";
    }
  }

  // Add click event listener to each switcher item
  switcherItems.forEach((item) => {
    item.addEventListener("click", function (event) {
      event.preventDefault();

      // Remove 'active' class from all switcher items
      switcherItems.forEach((i) => {
        i.classList.remove("active");
      });

      // Add 'active' class to the clicked switcher item
      item.classList.add("active");

      // Get the plan logo from the clicked switcher item
      const planLogo = item.getAttribute("data-plan-logo");

      // Show the corresponding plan
      showPlan(planLogo);
    });
  });
  // Show the first plan by default
  const firstPlanLogo = switcherItems[0].getAttribute("data-plan-logo");
  showPlan(firstPlanLogo);
});
